export const parseBooleanParam = (value: string | null): boolean | undefined => {
    if (value === null || value === '') return undefined;

    const v = value.toLowerCase();

    if (v === 'true') return true;
    if (v === 'false') return false;

    return undefined;
};
